"use client"

import { Button } from "@/components/ui/Button"
import { getClientUserEmail } from "@/features/bookmarks"
import { Shield } from "lucide-react"
import Link from "next/link"
import { useEffect, useState } from "react"

/**
 * Navigation button for requesting access to UIC services and resources
 * Only shows if user is authenticated.
 */
export default function RequestAccessButton() {
  const [userEmail, setUserEmail] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Fetch user email on component mount
    getClientUserEmail()
      .then(setUserEmail)
      .finally(() => setIsLoading(false))
  }, [])

  // Don't render during loading or if not authenticated
  if (isLoading || !userEmail) {
    return null
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className="gap-2"
      aria-label="Request access"
      asChild
    >
      <Link href="/request/access">
        <Shield className="h-4 w-4" />
        <span className="hidden sm:inline">Request access</span>
      </Link>
    </Button>
  )
}
